import React from 'react';
import { Nav } from '../layouts/header';
import { ToothZapFooter } from '../layouts/footer';
import '../style/about-us.css';

const NAP = {
  name: 'ToothZap',
  email: 'hello@toothzap.in',
  phone: '+91-00000-00000',
  address: 'New Delhi, India',
};

export const AboutUs: React.FC = () => {
  return (
    <div className="about-page">
      <Nav />

      <section className="mx-auto max-w-5xl px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="text-4xl leading-tight text-dark sm:text-5xl">
          About ToothZap
        </h1>

        <div className="mt-12 grid gap-8">
          <section className="rounded-[2rem] border border-border bg-surface p-8">
            <h2 className="text-2xl text-dark">Mission statement</h2>
            <p className="mt-4 max-w-3xl text-base leading-7 text-mid">
              ToothZap exists to make same-day crown delivery operationally
              realistic for Delhi clinics, milling hubs, and patients. The
              goal is to compress the time between scan upload and final
              fitment without forcing every clinic to build the full
              production stack in-house.
            </p>
          </section>

          <section className="rounded-[2rem] border border-border bg-surface p-8">
            <h2 className="text-2xl text-dark">How it started</h2>
            <p className="mt-4 max-w-3xl text-base leading-7 text-mid">
              ToothZap started from a simple observation: digital dentistry
              had already made scan capture fast, but the workflow after that
              was still fragmented. Clinics, milling partners, and delivery
              coordination were moving at different speeds, so same-day
              restorative treatment stayed difficult even when the underlying
              technology already existed.
            </p>
          </section>

          <section className="rounded-[2rem] border border-border bg-surface p-8">
            <h2 className="text-2xl text-dark">The team</h2>
            <p className="mt-4 max-w-3xl text-base leading-7 text-mid">
              Team details will be added here as ToothZap grows. For launch,
              this section is a placeholder for founder, operations, and
              partner-network information.
            </p>
          </section>

          <section className="rounded-[2rem] border border-border bg-surface p-8">
            <h2 className="text-2xl text-dark">NAP block</h2>
            <address className="mt-4 text-base not-italic leading-7 text-mid">
              {NAP.name}
              <br />
              {NAP.email}
              <br />
              {NAP.phone}
              <br />
              {NAP.address}
            </address>
          </section>
        </div>
      </section>

      <ToothZapFooter />
    </div>
  );
};

export default AboutUs;